<template>
    <div id="language" class="page">
		<v-list v-if="languages.length" nav class="pa-0">
			<v-list-item
				v-for="language in languages"
				:key="language.Id"
				:to="{ name: 'language', params: { subjectId: language.Id } }"
				class="language-item"
			>
				<v-list-item-title>{{language.Name}}</v-list-item-title>
				<v-list-item-action>
					<v-icon>mdi-chevron-left</v-icon>
				</v-list-item-action>
			</v-list-item>
		</v-list>

		<div v-else-if="!languages.length" class="text-center mt-13">
			لا يوجد لغات مضافة
		</div>
    </div>
</template>

<script>
export default {
	name: 'Languages',

	data() {
		return {
			languages: []
		}
	},

	created() {
		this.$eventBus.$emit('page-loader', true);
		this.$store.dispatch('languages/fetchSubjects').then(data => {
			this.languages = data.map(c => ({ Id: c.id, Name: c.name }));
			if (this.languages.length === 1) {
				this.$router.replace({ name: 'language', params: { subjectId: this.languages[0].Id } })
			}
		}).finally(() => {
			this.$eventBus.$emit('page-loader', false);
		});
	}
}
</script>

<style lang="scss" scoped>
#language {
	.language-item {
		border: thin solid rgba(0, 0, 0, 0.12);
		border-radius: 10px;
	}
}
</style>